import { render, staticRenderFns } from "./DetourDateComponent.vue?vue&type=template&id=18123cbf&"
import script from "./DetourDateComponent.vue?vue&type=script&lang=js&"
export * from "./DetourDateComponent.vue?vue&type=script&lang=js&"
import style0 from "./DetourDateComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports